import { makeStyles } from '@material-ui/core/styles';
import { theme } from '../../styles/theme';
import { primaryText, white, sunSet, boxShadow1, oat, gray } from '../../utils/CssGlobalVariables';

export const useStyle = makeStyles({
    PrequalFormContainer: {
        position: 'relative',
    },
  
    PrequalBackGround: {
        display: 'flex',
        maxWidth: '100vw',
        backgroundRepeat: 'no-repeat',
        justifyContent: 'center',
        alignItems: 'center',

        '@media (min-width:0px) and (max-width:333px)': {
            justifyContent: 'center',
            alignItems: 'flex-start',
        },
        '@media (min-width:334px) and (max-width:599px)': {
            justifyContent: 'center',
            alignItems: 'flex-start',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            justifyContent: 'center',
            alignItems: 'flex-start',
        },
        '@media (min-width:1020px)': {
            minHeight: '28.75rem',
        },
    },
    PrequalBannerCurve: {
        position: 'absolute',
        width: '100%',
        '@media (min-width:0px) and (max-width:333px)': {
            bottom: '0rem',
            height: '44px',
        },
        '@media (min-width:334px) and (max-width:599px)': {
            bottom: '0rem',
            height: '44px',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            bottom: '-0.05rem',
            height: '44px',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '24.8rem',
            height: '64px',
        },
        '@media (min-width:1231px)': {
            top: '24.8rem',
            height: '64px',
        },
    },
    PrequalContainer: {
        display: ' flex',
        marginLeft: 'auto',
        marginRight: 'auto',
        '@media (min-width:0px) and (max-width:599px)': {
            flexDirection: 'column-reverse',
            maxWidth: '100vw',
            minWidth: '100vw',
            justifyContent: 'flex-end',
            alignItems: 'center',
            height: 'inherit',
           // backgroundColor: props => (props.changeBackGroundColor ? 'none' : '#470A68'),
        },

        '@media (min-width:600px) and (max-width:1019px)': {
            flexDirection: 'column-reverse',
            maxWidth: '100vw',
            minWidth: '100vw',
            justifyContent: 'flex-end',
            alignItems: 'center',
            height: 'inherit',
           // backgroundColor: props => (props.changeBackGroundColor ? 'none' : '#470A68'),
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            minWidth: '97vw',
            flexDirection: 'row',
        },
        '@media (min-width:1231px)': {
            minWidth: '76.8rem',
            flexDirection: 'row',
        },
    },
    PrequalLeftPart: {
        '@media (min-width:0px) and (max-width:599px)': {
            maxWidth: '100vw',
            width: '100%',
            paddingBottom: '2.75rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: '100vw',
            width: '100%',
            paddingBottom: '2.75rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            maxWidth: '50vw',
            marginRight: 'auto',
        },
        '@media (min-width:1231px)': {
            maxWidth: '50vw',
            marginRight: 'auto',
        },
    },
    PrequalHeadingText: {
        position: 'relative',
        flexWrap: 'wrap',
        fontFamily: theme.typography.h1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 'bold',

        '@media (min-width:0px) and (max-width:333px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            letterSpacing: '0.015625rem',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:334px) and (max-width:424px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            letterSpacing: '0.015625rem',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:425px) and (max-width:599px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            letterSpacing: '0.015625rem',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.h2.fontSize,
            lineHeight: theme.typography.h2.lineHeight,
            letterSpacing: '-0.03125rem',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            maxWidth: '35.75rem',
            top: '7rem',
            fontSize: theme.typography.h1.fontSize,
            lineHeight: theme.typography.h1.lineHeight,
            letterSpacing: '-0.03125rem',
        },
        '@media (min-width:1231px)': {
            maxWidth: '35.75rem',
            top: '6rem',
            fontSize: theme.typography.h1.fontSize,
            lineHeight: theme.typography.h1.lineHeight,
            letterSpacing: '-0.03125rem',
        },
    },
    PrequalSubHeadingText: {
        position: 'relative',
        flexWrap: 'wrap',
        fontFamily: theme.typography.h1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 400,
        '@media (min-width:0px) and (max-width:336px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:337px) and (max-width:424px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:425px) and (max-width:599px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '7.5rem',
            width: '36.75rem',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
        },
        '@media (min-width:1231px)': {
            top: '6.8rem',
            width: '36.75rem',
            fontSize: theme.typography.h3.fontSize,
            lineHeight: theme.typography.h3.lineHeight,
        },
    },
    CTAInputContainer: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'space-between',
        '@media (min-width:0px) and (max-width:599px)': {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginBottom: '1.5rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginBottom: '1.5rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '10rem',
            width: '34rem',
        },
        '@media (min-width:1231px)': {
           top: '10rem',
           width: '38rem',
        },
    },
    UnderMaintenanceContainer: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'space-between',
        alignItems: 'center',
        '@media (min-width:0px) and (max-width:599px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginBottom: '1.5rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginBottom: '1.5rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
         top: '10rem',
         width: '35.5rem',
        },
        '@media (min-width:1231px)': {
            top: '10rem',
            width: '38rem',
        },
    },
    UnderMaintenanceText: {
        fontFamily: theme.typography.body1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 400,
        fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.body1.lineHeight,
        color: white,
        textAlign: 'left',
        '@media (max-width:1019px)': {
            textAlign: 'center',
        },
        '@media (min-width:1020px)': {
            paddingRight: '1.5rem',
        },
    },
    CTAInputBox: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '2.5rem',
        '@media (min-width:0px) and (max-width:599px)': {
            maxHeight: '2.875rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxHeight: '2.5rem',
        },
        '& .MuiOutlinedInput-root': {
            padding: '0rem !important',
            height: '2.5rem',
            '@media (min-width:0px) and (max-width:599px)': {
                height: '2.875rem',
            },
            '@media (min-width:600px) and (max-width:1019px)': {
                height: '2.5rem',
            },
            '& .MuiAutocomplete-input': {
                '@media (min-width:0px) and (max-width:599px)': {
                    fontSize: theme.typography.body1.fontSize ,
                    lineHeight: '1.1875rem',
                },
                '@media (min-width:600px) and (max-width:1019px)': {
                    fontSize: theme.typography.body2.fontSize,
                    lineHeight: '1.125rem',
                },
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            top: '0rem',
        },
    },
    CTAInput: {
        background: white,
        maxHeight: '2.5rem',
        borderRadius: '.2rem',
        borderWidth: '1px',
        '@media (min-width:0px) and (max-width:599px)': {
            marginLeft: 'auto',
            marginRight: 'auto',
            width: 'calc(290 / 320 * 100vw)',
            maxHeight: '2.875rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '70vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            width: '20rem',
            marginRight: 'auto',
        },
        '@media (min-width:1231px)': {
            maxWidth: '24rem',
            marginRight: 'auto',
        },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E40046',
            border: '1px solid !important',
            top: '-0.3rem',
            borderRadius: '3px',
        },
        '& .MuiOutlinedInput-root.Mui-error ': {
            color: '#E40046',
        },
    },
    CTAInputEmpty: {
        background: white,
        maxHeight: '2.5rem',
        borderRadius: '.2rem',
        borderWidth: '1px',
        '@media (min-width:0px) and (max-width:599px)': {
            marginLeft: 'auto',
            marginRight: 'auto',
            width: 'calc(290 / 320 * 100vw)',
            maxHeight: '2.875rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '70vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            width: '20rem',
            marginRight: 'auto',
        },
        '@media (min-width:1231px)': {
            maxWidth: '24rem',
            marginRight: 'auto',
        },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E40046',
            border: '1px solid !important',
            top: '-0.3rem',
            borderRadius: '3px',
        },
        '& .MuiOutlinedInput-root.Mui-error ': {
            color: '#E40046',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFBA0D',
            border: '2px solid !important',
            top: '-0.3rem',
            borderRadius: '3px',
            color: '#FFBA0D',
        },
    },
    AutocompleteTextField: {
        maxHeight: '2.5rem',
        '@media (min-width:0px) and (max-width:333px)': {
            width: 'calc(290 / 320 * 100vw)',
            maxHeight: '2.875rem',
        },
        '@media (min-width:334px) and (max-width:599px)': {
            width: 'calc(290 / 320 * 100vw)',
            maxHeight: '2.875rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            width: '70vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            width: '20rem',
        },
        '@media (min-width:1231px)': {
            width: '24rem',
        },
    },
    AutocompleteListItems: {
        '& .MuiAutocomplete-listbox': {
            '& :hover': {
                color: theme.palette.secondary.main,
                backgroundColor: white,
            },
            '& :not(active)': {
                backgroundColor: white,
            },
            '& li': {
                textTransform: 'capitalize',
                fontSize: theme.typography.body1.fontSize,
            },
            '&::-webkit-scrollbar': {
                width: '18px',
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: white,
                boxShadow: 'inset 1px 0px 0px #DEDEDE',
            },
            '&::-webkit-scrollbar-thumb': {
                width: '6px',
                height: '50px',
                borderRadius: '14px',
                borderRight: '3px solid transparent',
                borderLeft: '4px solid transparent',
                borderTop: '6px solid transparent',
                borderBottom: '6px solid transparent',
                backgroundClip: 'padding-box',
                backgroundColor: '#9E9E9E',
            },
        },
    },
    AutocompleteNotFound: {
        minHeight: '1.25rem',
        height: '100%',
        fontFamily: theme.typography.body1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: '400',
        fontSize: theme.typography.overline,
        lineHeight: theme.typography.caption.lineHeight,
        color: '#323435',
        textTransform: 'none',

        '& :hover': {
            color: theme.palette.secondary.main,
        },
        '& .AutocompleteNotFound-highlighted': {
            textDecorationLine: 'underline',
            color: theme.palette.secondary.main,
        },
    },
    TextFieldIconImage: {
        marginLeft: '0.5rem',
        marginRight: '0.5rem',
        '@media (min-width:0px) and (max-width:599px)': {
            marginLeft: '1.0625rem',
            marginRight: '0.5625rem',
        },
    },
    CTAButton: {
        backgroundColor: primaryText,
        color: white,
        fontFamily: theme.typography.body1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 'bold',
        borderRadius: '2rem',
        minWidth: '11.5rem',
        maxHeight: '2.5rem',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        '@media (min-width:0px) and (max-width:599px)': {
            width: 'calc(262 / 320 * 100vw)',
            marginTop: '1.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            padding: '0.5rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '1.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            padding: '0.5rem',
            width: '50vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            left: '-1rem',
        },
        '@media (min-width:1231px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            left: '-1rem',
        },
        '&:disabled': {
            color: '#959596',
            boxShadow: 'none',
            backgroundColor: white,
            border: '1px solid #959596 !important',
        },
        '&:focus': {
            outline: 'none',
        },
    },
    UnderMaintenanceCTA: {
        '@media (min-width:1020px)': {
            display: 'flex',
            justifyContent: 'flex-end',
        },
    },
    UnderMaintenanceCTAButton: {
        backgroundColor: theme.palette.secondary.main,
        color: white,
        fontFamily: theme.typography.body1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 'bold',
        borderRadius: '2rem',
        minWidth: '11.5rem',
        maxHeight: '2.5rem',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        '@media (min-width:0px) and (max-width:599px)': {
            width: 'calc(262 / 320 * 100vw)',
            marginTop: '1.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            padding: '0.5rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '1.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            padding: '0.5rem',
            width: '50vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '@media (min-width:1231px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '&:disabled': {
            color: '#888B8D',
            boxShadow: 'none',
            backgroundColor: '#ECECEC',
        },
        '&:focus': {
            outline: 'none',
        },
    },
    CTAButtonExtraMargin: {
        '@media (min-width:0px) and (max-width:599px)': {
            marginTop: '3rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '3rem',
        },
    },
    AddressNotFound: {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        '@media (min-width:0px) and (max-width:333px)': {
            width: '100vw',
            marginTop: '0.5rem',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '@media (min-width:334px) and (max-width:599px)': {
            width: '100vw',
            marginTop: '0.5rem',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            width: '100vw',
            marginTop: '0.5rem',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '11.5rem',
            width: '24rem',
        },
        '@media (min-width:1231px)': {
            top: '11.5rem',
            width: '24rem',
        },
    },
    AddressNotFoundText: {
        fontSize: theme.typography.overline.fontSize,
        fontFamily: theme.typography.body1.fontFamily,
        lineHeight: theme.typography.caption.lineHeight,
        // fontWeight: 400,
        // fontStyle: 'normal',
        letterSpacing: '0.025rem',
        color: white,
        '@media (min-width:0px) and (max-width:333px)': {},
        '@media (min-width:334px) and (max-width:424px)': {},
        '@media (min-width:425px) and (max-width:599px)': {},
        '@media (min-width:600px) and (max-width:1019px)': {},
    },
    AddressNotFoundLink: {
        fontSize: theme.typography.overline.fontSize,
        fontFamily: theme.typography.body1.fontFamily,
        lineHeight: theme.typography.caption.lineHeight,
        color: theme.palette.secondary.main,
        textDecoration: 'underline',
        marginLeft: '.2rem',
        cursor: 'pointer',
        '@media (min-width:0px) and (max-width:333px)': {
            textAlign: 'center',
            fontSize: theme.typography.overline.fontSize,
            lineHeight: theme.typography.caption.lineHeight,
        },
        '@media (min-width:334px) and (max-width:424px)': {
            textAlign: 'center',
            fontSize: theme.typography.overline.fontSize,
            lineHeight: theme.typography.caption.lineHeight,
        },
        '@media (min-width:425px) and (max-width:599px)': {
            textAlign: 'center',
            fontSize: theme.typography.overline.fontSize,
            lineHeight: theme.typography.caption.lineHeight,
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            textAlign: 'center',
        },
    },
    EircodeValidity: {
        // fontStyle: 'normal',
        // fontWeight: 400,
        fontSize: theme.typography.subtitle2.fontSize,
        letterSpacing: '0.025rem',
        color: white,
        position: 'relative',
        fontFamily: theme.typography.body1.fontFamily,
        lineHeight: theme.typography.caption.lineHeight,
        '@media (min-width:0px) and (max-width:333px)': {
            marginTop: '0.1875rem',
        },
        '@media (min-width:334px) and (max-width:599px)': {
            marginTop: '0.1875rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '0.1875rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '.4rem',
        },
        '@media (min-width:1231px)': {
            top: '.4rem',
        },
    },
    PhoneValidity: {
        // fontStyle: 'normal',
        // fontWeight: 400,
        fontSize: theme.typography.subtitle2.fontSize,
        letterSpacing: '0.025rem',
        color: white,
        position: 'relative',
        fontFamily: theme.typography.body1.fontFamily,
        lineHeight: theme.typography.caption.lineHeight,
        '@media (min-width:0px) and (max-width:333px)': {
            marginTop: '0.125rem',
        },
        '@media (min-width:334px) and (max-width:599px)': {
            marginTop: '0.125rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '0.125rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '-0.125rem',
        },
        '@media (min-width:1231px)': {
            top: '-0.125rem',
        },
    },
    PhoneInputContainer: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'space-between',
        '@media (min-width:0px) and (max-width:599px)': {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '2.5rem',
            marginBottom: '1.5rem',
            width: '100vw',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '2.5rem',
            marginBottom: '1.5rem',
            width: '100vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '10rem',
            width: '32rem',
        },
        '@media (min-width:1231px)': {
            top: '9rem',
            width: '36rem',
        },
        '& .MuiFormControl-marginNormal': {
            marginTop: '0rem',
        },
    },
    PrequalAreaCode: {
        fontFamily: theme.typography.body1.fontFamily,
        borderRadius: '0.25rem',
        backgroundColor: white,
        textAlign: 'left',
        padding: '10px',
        // fontStyle: 'normal',
        // fontWeight: 400,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: '19px',
        '@media (min-width:0px) and (max-width:332px)': {
            width: 'calc(94 / 320 * 100vw)',
            height: '3rem',
        },
        '@media (min-width:333px) and (max-width:399px)': {
            width: 'calc(94 / 320 * 100vw)',
            height: '3rem',
        },
        '@media (min-width:400px) and (max-width:599px)': {
            width: 'calc(94 / 320 * 100vw)',
            height: '3rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            width: 'calc(94 / 299 * 100%)',
            height: '3rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            width: '5.875rem',
            height: '2.5rem',
        },
        '@media (min-width:1231px)': {
            width: '5.875rem',
            height: '2.5rem',
        },
        '& .MuiSelect-select': {
            background: white,
            // paddingRight: '0px'
        },
        '&.Mui-error': {
            border: '1px solid #E40046',
            color: '#E40046',
        },
        '& .MuiSvgIcon-root': {
            color: theme.palette.secondary.main,
            right: '0.4rem',
        },
    },
    AreaCodeNullColor: {
        color: '#2c292973',
    },
    AreaCodeFilledColor: {
        color: primaryText,
    },
    PrequalPhoneNumber: {
        fontFamily: theme.typography.body1.fontFamily,
        background: white,
        borderRadius: '0.25rem',
        margin: '0rem',
        fontStyle: 'normal',
        '@media (min-width:0px) and (max-width:332px)': {
            height: '2.875rem',
            width: 'calc(189 / 320 * 100vw)',
        },
        '@media (min-width:333px) and (max-width:399px)': {
            height: '2.875rem',
            width: 'calc(189 / 320 * 100vw)',
        },
        '@media (min-width:400px) and (max-width:599px)': {
            height: '2.875rem',
            width: 'calc(189 / 320 * 100vw)',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            height: '2.875rem',
            width: 'calc(189 / 299 * 100%)',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            height: '3rem',
        },
        '@media (min-width:1020px)': {
            height: '2.5rem',
            width: '13.75rem',
        },
        '& .MuiOutlinedInput-root': {
            padding: '0rem !important',
            height: '2.5rem',
            fontWeight: 400,
            fontSize: theme.typography.body1.fontSize,
            lineHeight: '19px',
            '@media (min-width:0px) and (max-width:599px)': {
                height: '2.875rem',
            },
            '@media (min-width:600px) and (max-width:1019px)': {
                height: '2.875rem',
            },
        },
        '& .MuiOutlinedInput-root.Mui-error ': {
            color: '#E40046 !important',
        },
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderWidth: '0rem',
        },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E40046',
            borderWidth: '1px !important',
            top: '-0.3rem',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 'inherit',
        },
        '& .MuiOutlinedInput-root.Mui-hover .MuiOutlinedInput-notchedOutline': {
            border: '0',
        },
        '& #prequal-phone-number::placeholder': {
            color: primaryText,
            fontFamily: theme.typography.body1.fontFamily,
        },
    },
    // TextFieldPlaceholder: {
    //     fontFamily: fontFamilyRegular,
    // },
    PhoneNumberTextFieldIconImage: {
        cursor: 'pointer',
        marginRight: '0.8rem',
    },
    PhoneNumberTextFieldTooltip: {
        padding: '4px 8px',
        width: 'fit-content',
    },
    toolTipText: {
        fontFamily: theme.typography.body1.fontFamily,
        // fontWeight: '200',
        fontSize: '12px',
        lineHeight: '14px',
    },
    PrequalPhoneNumberSubmitButton: {
        backgroundColor: theme.palette.secondary.main,
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'bold',
        borderRadius: '2rem',
        minWidth: '11.5rem',
        maxHeight: '2.5rem',
        textTransform: 'none',
        outline: 'none',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        '@media (min-width:0px) and (max-width:599px)': {
            width: 'calc(262 / 320 * 100vw)',
            marginTop: '1rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            padding: '0.5rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '1rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            width: '50vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            left: '1rem',
        },
        '@media (min-width:1231px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            marginLeft: '-5rem',
            left: '-2.5rem',
            top: 'auto',
        },
        '&:disabled': {
            color: '#888B8D',
            boxShadow: 'none',
            backgroundColor: '#ECECEC',
        },
        '&:focus': {
            outline: 'none',
        },
    },
    UseEircode: {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        '@media (min-width:0px) and (max-width:332px)': {
            marginTop: '0.25rem',
            width: 'calc(100vw - 1.6875rem)',
            marginLeft: '0.6875rem',
        },
        '@media (min-width:333px) and (max-width:399px)': {
            marginTop: '0.25rem',
            width: 'calc(100vw - 1.6875rem)',
            marginLeft: '0.6875rem',
        },
        '@media (min-width:400px) and (max-width:599px)': {
            marginTop: '0.25rem',
            width: 'calc(100vw - 1.6875rem)',
            marginLeft: '0.6875rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '0.25rem',
            width: '20rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '0.3rem',
            width: '20rem',
        },
        '@media (min-width:1231px)': {
            top: '0.3rem',
            width: '24rem',
        },
    },
    CodeAndNumberContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        '@media (min-width:0px) and (max-width:332px)': {
            flexDirection: 'row',
            marginLeft: '0.6875rem',
            marginRight: '0.625rem',
            width: 'calc(100vw - 1.3125rem)',
        },
        '@media (min-width:333px) and (max-width:399px)': {
            flexDirection: 'row',
            marginLeft: '0.6875rem',
            marginRight: '0.625rem',
            width: 'calc(100vw - 1.3125rem)',
        },
        '@media (min-width:400px) and (max-width:599px)': {
            flexDirection: 'row',
            marginLeft: '0.6875rem',
            marginRight: '0.625rem',
            width: 'calc(100vw - 1.3125rem)',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '67vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '20.50rem',
        },
        '@media (min-width:1231px)': {
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '20.75rem',
        },
    },
    NumberAndMessageContainer: {
        display: 'flex',
        '@media (min-width:0px) and (max-width:332px)': {
            flexDirection: 'column',
            width: '100vw',
        },
        '@media (min-width:333px) and (max-width:399px)': {
            flexDirection: 'column',
        },
        '@media (min-width:400px) and (max-width:599px)': {
            flexDirection: 'column',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            flexDirection: 'column',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            flexDirection: 'column',
        },
        '@media (min-width:1231px)': {
            flexDirection: 'column',
        },
    },
    AfterPrequalParagraph: {
        display: 'flex',
        position: 'relative',
        height: '4.5625rem',
        '@media (min-width:0px) and (max-width:332px)': {
            flexDirection: 'column',
            maxWidth: 'calc(100% - 1.875rem)',
            marginTop: '2rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
            textAlign: 'center',
            height: 'unset',
        },
        '@media (min-width:333px) and (max-width:399px)': {
            flexDirection: 'column',
            maxWidth: 'calc(100% - 1.875rem)',
            marginTop: '2rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
            textAlign: 'center',
            height: 'unset',
        },
        '@media (min-width:400px) and (max-width:599px)': {
            flexDirection: 'column',
            maxWidth: 'calc(100% - 1.875rem)',
            marginTop: '2rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
            textAlign: 'center',
            height: 'unset',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            flexDirection: 'column',
            maxWidth: 'calc(100% - 1.875rem)',
            marginTop: '2rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
            textAlign: 'center',
            height: 'unset',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            flexDirection: 'column',
            width: '30.375rem',
            top: '9rem',
        },
        '@media (min-width:1231px)': {
            flexDirection: 'column',
            width: '30.375rem',
            top: '8.4375rem',
        },
    },
    ParagraphText: {
        fontFamily: theme.typography.subtitle1.fontFamily,
        textTransform: 'capitalize',
        fontSize: theme.typography.body1.fontSize,
        '@media (min-width:0px) and (max-width:599px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
    },
    NotBoldParagraphText: {
        fontFamily: theme.typography.body1.fontFamily,
        textTransform: 'capitalize',
        fontSize: theme.typography.body1.fontSize,
    },
    ChangeAddressText: {
        fontFamily: theme.typography.body1.fontFamily,
        position: 'relative',
        textDecoration: 'underline',
        fontSize: theme.typography.subtitle2.fontSize,
        '@media (min-width:0px) and (max-width:599px)': {
            marginTop: '0.25rem',
            fontSize: '14px',
            lineHeight: '24px',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '0.25rem',
            fontSize: theme.typography.subtitle2.fontSize,
            lineHeight: '24px',
        },
        '@media (min-width:1020px)': {
            top: '0.5rem',
        },
        '&:hover': {
            cursor: 'pointer',
        },
    },
    PrequalRightPart: {
        display: 'flex',
        justifyContent: 'center',
        maxHeight: '100%',
        '@media (min-width:0px) and (max-width:599px)': {
            width: '100vw',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            width: '100vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            height: '28rem',
            width: '28rem',
            marginLeft: 'auto',
        },
        '@media (min-width:1231px)': {
            height: '28.75rem',
            width: '29.125rem',
            marginLeft: 'auto',
        },
    },
    PrequalBanner: {
        marginTop: 'auto',
        marginBottom: 'auto',
        '@media (min-width:0px) and (max-width:333px)': {
            maxWidth: '100vw',
            height: '10rem',
        },
        '@media (min-width:334px) and (max-width:599px)': {
            maxWidth: '100vw',
            height: '10rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: '100vw',
            height: '16rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            width: 'auto',
            height: 'auto',
        },
        '@media (min-width:1231px)': {
            width: 'auto',
            height: 'auto',
        },
    },
    // BundleCard Styles
    BundleCardContainerWrapper: {
        marginTop: '2.5rem',
        marginBottom: '2.5rem',
    },
    BundleContainerTitle: {
        position: 'relative',
        color: primaryText,
        fontSize: '2.5rem',
        width: 'fit-content',
        lineHeight: '3rem',
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontStyle: 'normal',
        fontWeight: '400',
        letterSpacing: '-0.03125rem',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        '@media (max-width:611px)': {
            fontSize: '24.57px',
            lineHeight: '33px',
        },
    },
    SubTitleAfterPrequal:{
        fontFamily: theme.typography.body1.fontFamily,
        fontSize: theme.typography.body1.fontSize,
        fontWeight: '400',
        lineHeight: '24px',
        letterSpacing:'0px',
        textAlign: 'center',
        color:'#323435',
        paddingTop:'16px',
    },
    BundleCardContainer: {
        maxWidth: '918px',
        marginLeft: 'auto',
        marginRight: 'auto',

        '& .slick-slider': {
            paddingBottom: '48px !important',
            '& .slick-list': {
                overflow: 'visible',
                height: 'auto !important',
            },
        },
        '& .slick-slider': {
            '& .slick-list': {
                height: 'auto !important',
                '& .slick-slide.slick-active.slick-center.slick-current': {
                    transform: 'scale(1)',
                },
                '& .slick-track': {
                    marginTop: '40px',
                    marginBottom: '48px',

                    '@media (max-width:611px)': {
                        marginTop: '32px',
                        marginBottom: '56px',
                    },
                },
            },
            '& .slick-dots': {
                bottom: '14px',

                '@media (max-width:611px)': {
                    bottom: '18px',
                },
            },
            '& .slick-dots li.slick-active button:before': {
                color: primaryText,
            },
            '& .slick-dots li button:before': {
                fontSize: '8px',
                color: 'rgba(50, 52, 53, 0.38)',
            },
            '& .slick-dots li': {
                width: '8px',
            },
        },
        '@media (min-width:918px)(max-width: 1024px)': {},
        '@media(max-width: 917px)': {
            maxWidth: '612px',
        },

        '@media(max-width: 611px)': {
            '& .slick-slider': {
                '& .slick-list': {
                    '& .slick-slide': {
                        transform: 'scaleY(0.945)',
                    },
                },
            },

            '& .slick-track': {
                height: 'max-content !important',

                '& .slick-active': {
                    '& > *:first-child': {
                        '& > *:first-child': {
                            boxShadow: '0px 0px 16px 4px rgba(137, 43, 160, 0.25)',
                            borderColor: props =>
                props.useBroadbandCardColor ? props.themeColorForBroadbandCardsHover : props.themeColorOnHover,
                        },
                    },
                },
            },
            marginLeft: 'unset',
            marginRight: 'unset',
        },

        '& .cardAttrBold': {
            color: props =>
                props.useBroadbandCardColor ? props.themeColorForBroadbandCards : props.themeColor,
            fontFamily: theme.typography.subtitle1.fontFamily,
            fontStyle: 'normal',
            fontWeight: 700,
        },
    },
    SingleCardContainer: {
        '@media(max-width: 611px)': {
            '& .slick-slider': {
                '& .slick-list': {
                    '& .slick-slide': {
                        width: '100%',
                    },
                },
            },
        },
    },
    bundleCardContainerCheckAvailabilityButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100vw',
        position: 'relative',
        height: '2.5rem',
    },
    bundleCardContainerCheckAvailabilityButton: {
        backgroundColor: sunSet,
        color: gray,
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'bold',
        minWidth: '11.5rem',
        maxHeight: '2.5rem',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: sunSet,
        },
        '@media (min-width:0px) and (max-width:599px)': {
            width: '80vw',
            // top: '1.3rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            // top: '1.2rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            width: '50vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        '@media (min-width:1231px)': {
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        '&:focus': {
            outline: 'none',
        },
    },
    BundleCard: {
        marginLeft: 'auto',
        marginRight: 'auto',
        border: '3px solid ',
        borderColor: props =>
            props.useBroadbandCardColor ? props.themeColorForBroadbandCards : props.themeColor,
        boxSizing: 'border-box',
        boxShadow: boxShadow1,
        borderRadius: '10px',
        '&:hover': {
            transition: 'transform 0.25s ease-in-out',
            transform: 'scale3d(1.05, 1.05, 1)',
            border: '3px solid ',
            borderColor: props =>
                props.useBroadbandCardColor ? props.themeColorForBroadbandCardsHover : props.themeColorOnHover,
            boxSizing: 'border-box',
            boxShadow: '0px 0px 16px 4px rgba(137, 43, 160, 0.25)',
            borderRadius: '9px',
        },
        maxWidth: '282px',
        width: '282px',
        '@media (max-width:611px)': {
            marginLeft: '4px',
            marginRight: '4px',
            '&:hover': {
                transition: 'none !important',
                transform: 'none !important',
            },
        },
        '@media (max-width:305px)': {
            marginLeft: 'auto',
            marginRight: 'auto',
            width: 'calc(min(100vw, 282px))',
        },
    },
    SingleCard: {
        '@media (max-width:611px)': {
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    BundleCardSlider: {
        borderRadius: 'none',
        '& .slick-list': {
            textAlign: 'center',
            '& .slick-dots li.slick-active button:before': {
                color: primaryText,
            },
            '& .slick-dots li button:before': {
                fontSize: '8px',
            },
        },
    },

    BundleCardHeader: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    BundleCardHeaderImage: {
        marginTop: '-2px',
        marginLeft: '-2px',
        marginRight: '-2px',
        marginBottom: '-2px',
    },
    BundleCardHeaderContainer: {
        fontFamily: theme.typography.body1.fontFamily,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: white,
        color: primaryText,
        padding: '0.4rem 3.81rem',
    },
    BundleCardHeaderContainerHover: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: white,
        color: primaryText,
        padding: '0.4rem 3.81rem',
    },
    fixedBundleCardBody: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        borderRadius: 'none',
        paddingBottom: '20px',
        backgroundColor: oat,
        // maxHeight:'491px',
    },
    bundlePrice: {
        position: 'static',
        width: 'auto',
        maxHeight: '32px',
        marginLeft: '16px',
        marginRight: '16px',
        marginTop: '20px',
        fontFamily: theme.typography.subtitle1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: theme.typography.body1.fontSize, 
        lineHeight: theme.typography.h4.lineHeight,
        color: props =>
            props.useBroadbandCardColor ? props.themeColorForBroadbandCards : props.themeColor,
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    bundleSubTitle: {
        fontFamily: theme.typography.body1.fontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: theme.typography.overline.fontSize ,
        lineHeight: theme.typography.inputText.lineHeight,
        color: primaryText,

        marginLeft: '16px',
        marginRight: '16px',
        textAlign: 'center',
    },
    bundleCardContent: {
        marginLeft: '16px',
        marginRight: '16px',
        marginTop: '11px',
        fontFamily: theme.typography.body1.fontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.inputText.lineHeight,
        color: primaryText,
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    prequalBundleCardType: {
        margin: '1rem 1.5rem 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    prequalBundleCardImage: {
        width: '1.988125rem',
        height: '1.988125rem',
        flex: '0 0 1.988125rem',
        background: props =>
            props.useBroadbandCardColor ? props.themeColorForBroadbandCards : props.themeColor,
        borderRadius: '1.3253rem',
        marginRight: '1rem',
        textAlign: 'center',

        '& img': {
            display: 'unset',
        },
    },
    prequalBundleCardTypeAttributes: {
        color: primaryText,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.inputText.lineHeight,
        fontFamily: theme.typography.body1.fontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
        textAlign: 'left',

        '& a,& a:hover': {
            color: sunSet,
        },
    },
    ContentRoot: {
        borderRadius: 0,
    },
    Content: {
        display: 'flex',
        width: '100%',
        backgroundColor: props =>
            props.useBroadbandCardColor ? props.themeColorForBroadbandCards : props.themeColor,
        color: white,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.inputText.lineHeight,
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 23px 4px 23px !important',

        '& p': {
            fontFamily: theme.typography.body1.fontFamily,
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
    },
    PrequalBundleCardFooterArrow: {
        transform: 'rotate3d(0, 0, 1, 180deg)',
    },
    ContentHover: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        maxHeight: '37px',
        color: white,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.inputText.lineHeight,
        alignItems: 'center',
        padding: '6px 23px 4px 23px !important',
        backgroundColor: props =>
            props.useBroadbandCardColor ? props.themeColorForBroadbandCardsHover : props.themeColorOnHover,

        '& p': {
            fontFamily: theme.typography.body1.fontFamily,
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
    },
    PrequalBundleCardFooter: {
        width: 'auto',
        backgroundColor: props =>
            props.useBroadbandCardColor ? props.themeColorForBroadbandCards : props.themeColor,
        height: 'auto',
        color: `${white} !important`,
        display: 'flex',
        alignItems: 'left',
        textAlign: 'left',
        cursor: 'pointer',
        justifyContent: 'center',
        padding: '0 21px 21px !important',
        '& ul': {
            // listStylePosition: 'inside',
            listStyleType: 'none',
            padding: 0,
            marginBottom: 0,
        },
        '& li': {
            marginTop: '24px',

            // '& ::before': {
            //     content: `''`,
            //     marginRight: '-0.8rem',
            // },
            '& *': {
                display: 'inline',
                fontFamily: theme.typography.body1.fontFamily,
                color: `${white} !important`,
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: theme.typography.body1.fontSize,
                lineHeight: theme.typography.inputText.lineHeight,
            },
            '& .moreInfoUnderline': {
                textDecoration: 'underline',
            },
            '& .moreInfoUnderline::before': {
                content: '\'\'',
                marginRight: '0rem',
            },
        },
        '& a': {
            color: white,
            // marginLeft: '1.6rem',
        },
    },
    PrequalBundleCardFooterHover: {
        backgroundColor: props =>
            props.useBroadbandCardColor ? props.themeColorForBroadbandCardsHover : props.themeColorOnHover,
    },
    prequalDialogueBox: {
        position: 'static',
        maxWidth: '300px',
        height: 'auto',
        background: '#F3F5F9',
        fontSize: theme.typography.body1.fontSize,
        wordBreak: 'break-word',
        overflow: 'unset',
        cursor: 'pointer',
    },
    customTooltip: {
        maxWidth: '242px',
        backgroundColor: white,
        color: primaryText,
        '& .MuiTooltip-arrow': {
            color: white,
        },
    },
    customTooltipFee: {
        maxWidth: '242px',
        marginLeft: '100px',
        backgroundColor: white,
        color: primaryText,
        '& .MuiTooltip-arrow': {
            color: white,
        },
        '@media (min-width:0px) and (max-width:340px)': {
            marginLeft: '32px',
            '& .MuiTooltip-arrow': {
                color: white,
                marginLeft: '-90px !important',
            },
        },
        '@media (min-width:341px) and (max-width:374px)': {
            marginLeft: '40px',
            '& .MuiTooltip-arrow': {
                color: white,
                marginLeft: '-90px !important',
            },
        },
        '@media (min-width:375px) and (max-width:599px)': {
            marginLeft: '80px',
            '& .MuiTooltip-arrow': {
                color: white,
                marginLeft: '-80px !important',
            },
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginLeft: '120px',
            '& .MuiTooltip-arrow': {
                color: white,
                marginLeft: '-150px !important',
            },
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            marginLeft: '120px',
            '& .MuiTooltip-arrow': {
                color: white,
                marginLeft: '-150px  !important',
            },
        },
        '@media (min-width:1231px)': {
            marginLeft: '115px',
            '& .MuiTooltip-arrow': {
                color: white,
                marginLeft: '-150px  !important',
            },
        },
    },
    closeIcon: {
        color: primaryText,
        marginLeft: 'auto',
    },
    customTooltipText: {
        width: '199px',
        color: `${white} !important`,
        fontFamily: theme.typography.body1.fontFamily,
        margin: '0px 10px 10px 10px',
        padding: '0px 10px 10px 10px',
        // fontWeight: '400',
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '1.375rem',
    },
    //we are sorry page styles
    WeAreSorryHeadingText: {
        position: 'relative',
        flexWrap: 'wrap',
        fontFamily: 'eir-medium',
        fontStyle: 'normal',
        fontWeight: 'bold',

        '@media (min-width:0px) and (max-width:333px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: '2.0625rem',
            letterSpacing: '0.015625rem',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:334px) and (max-width:424px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: '2.0625rem',
            letterSpacing: '0.015625rem',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:425px) and (max-width:599px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: '2.0625rem',
            letterSpacing: '0.015625rem',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: '2.5rem',
            lineHeight: '3rem',
            letterSpacing: '-0.03125rem',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '1rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            width: '47.3125rem',
            top: '4rem',
            fontSize: '2.5rem',
            lineHeight: '3rem',
            letterSpacing: '-0.03125rem',
        },
        '@media (min-width:1231px)': {
            maxWidth: '47.3125rem',
            top: '4rem',
            fontSize: '2.5rem',
            lineHeight: '3rem',
            letterSpacing: '-0.03125rem',
        },
    },
    WeAreSorrySubHeadingText: {
        position: 'relative',
        flexWrap: 'wrap',
        fontFamily: theme.typography.body1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 400,
        '@media (min-width:0px) and (max-width:424px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:425px) and (max-width:599px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '5rem',
            width: '41.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '@media (min-width:1231px)': {
            top: '5rem',
            width: '46.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
    },
    WeAreSorryCTAButton: {
        backgroundColor: theme.palette.secondary.main,
        color: white,
        fontFamily: theme.typography.body1.fontFamily,
        fontStyle: 'normal',
        fontWeight: '700',
        borderRadius: '2rem',
        minWidth: '13.75rem',
        minHeight: '2.5rem',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        '@media (min-width:0px) and (max-width:599px)': {
            width: 'calc(262 / 320 * 100vw)',
            marginTop: '-0.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            padding: '0.5rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            marginTop: '-0.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            padding: '0.5rem',
            width: '50vw',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '1.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '@media (min-width:1231px)': {
            top: '1.5rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '&:focus': {
            outline: 'none',
        },
    },
    WeAreSorryCTAButtonContainer: {
        position: 'relative',
        top: '0rem',
        '@media (min-width:0px) and (max-width:424px)': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '@media (min-width:425px) and (max-width:599px)': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '@media (min-width:1020px)': {
            top: '6rem',
            display: 'flex',

            alignItems: 'center',
        },
    },
    WeAreSorryPara1: {
        position: 'relative',
        flexWrap: 'wrap',
        fontFamily: theme.typography.body1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 400,
        '@media (min-width:0px) and (max-width:424px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:425px) and (max-width:599px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '1.5rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '-0.5rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '6rem',
            width: '28.25rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '@media (min-width:1231px)': {
            top: '6rem',
            width: '28.25rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
    },
    WeAreSorryPara2: {
        position: 'relative',
        flexWrap: 'wrap',
        fontFamily: theme.typography.body1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 400,
        '@media (min-width:0px) and (max-width:424px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            top: '-1rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '2rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:425px) and (max-width:599px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            top: '-1rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '2rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            maxWidth: 'calc(100% - 1.875rem)',
            top: '-1rem',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
            letterSpacing: 'unset',
            textAlign: 'center',
            marginTop: '2rem',
            marginBottom: '2rem',
            marginLeft: '0.9375rem',
            marginRight: '0.9375rem',
        },
        '@media (min-width:1020px) and (max-width:1230px)': {
            top: '9rem',
            width: '14rem',
            fontSize: theme.typography.subtitle2.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
        '@media (min-width:1231px)': {
            top: '8.5rem',
            width: '14rem',
            fontSize: theme.typography.subtitle2.fontSize,
            lineHeight: theme.typography.inputText.lineHeight,
        },
    },
    WeAreSorryPara2URL: {
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    prequalBundleButton: {
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontWeight: 'inherit',
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.h4.lineHeight,
        borderRadius: '0.375rem',
        textTransform: 'none',
        cursor: 'pointer',
        color: sunSet,
        backgroundColor: white ,
        border: '0.188rem solid'+sunSet ,
        '& :hover':{
            color: white,
            backgroundColor: sunSet,
            border: '0.188rem solid'+sunSet,
            },
        textTransform: 'none',
        padding: '8px 24px',
        display: 'flex',
        margin: '0 auto',
        width: '220px',
        '&:focus': {
            outline: 'none',
        },
    },
    prequalBundleButtonHover: {
        border: '0.188rem solid' +sunSet,
        borderRadius: '0.375rem',
        textTransform: 'capitalize',
        padding: '8px 24px',
        display: 'flex',
        margin: '0 auto',
        width: '220px',
        fontWeight: 700,
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontWeight: 'inherit',
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.h4.lineHeight,
        backgroundColor: sunSet,
        boxShadow: '0px 5px 10px -2px rgba(209, 17, 201, 0.45)',
        color: white,
        '&:focus': {
            outline: 'none',
        },
        '&:hover': {
            background: sunSet,
            boxShadow: '0px 5px 10px -2px rgba(209, 17, 201, 0.45)',
            borderRadius: '0.375rem',
            color: white,
        },
    },
    prequalCTAContainer: {
        marginTop: '28px',
        marginBottom: '8px',
    },
    LoadingStyle: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        top: '10rem',
        '@media (min-width:0px) and (max-width:599px)': {
            top: '0',
            justifyContent: 'center ',
        },
        '@media (min-width:600px) and (max-width:1019px)': {
            top: '0',
            justifyContent: 'center',
        },
    },
    LoadingText: {
        fontFamily: theme.typography.body1.fontFamily,
        // fontStyle: 'normal',
        // fontWeight: 400,
        color: white,
        fontSize: theme.typography.subtitle2.fontSize,
        marginTop: '0.2rem',
        marginLeft: '1rem',
    },
    LoadingDots: {
        width: '0.625rem !important',
        height: '0.625rem !important',
    },
     noOptions: {
    color: 'rgb(71, 10, 104) !important',
    fontSize: '14px !important',
  },
});
